import * as React from 'react'
import Milliseconds from '../../../helper/milliseconds'
import LargeNumber from '../../../helper/large-number'

interface Props {
    message?: {
        args: {
            ct: number
            wt: number
        }
    }
}

export default class DbalSqlParser extends React.PureComponent<Props> {
    render = () => {
        const { message } = this.props

        const doctrineLink =
            'https://tideways.com/profiler/blog/combining-regular-expressions-with-named-capture-groups-to-improve-performance'

        let info = (
            <p>
                The Doctrine DBAL SQL Parser took a long time to process SQL for <code>WHERE IN</code> queries.
            </p>
        )

        if (message) {
            info = (
                <p>
                    The Doctrine DBAL SQL Parser took a long time to process SQL for <code>WHERE IN</code> queries{' '}
                    <LargeNumber value={message.args.ct} class="" /> times for <Milliseconds value={message.args.wt} />.
                </p>
            )
        }

        return (
            <div>
                {info}

                <p>
                    Code relies heavily on the Doctrine DBAL SQL Parser to allow escaping an array of parameters, for example in a{' '}
                    <code>WHERE id IN (?)</code> query with <code>Doctrine\DBAL\Connection::PARAM_INT_ARRAY</code>.
                </p>
                <p>
                    For older versions of Doctrine DBAL this can be pretty expensive and got optimized in recent versions. You should make
                    sure to have the latest version, or use a Composer patch. See the <a href={doctrineLink}>Tideways blog post</a> for more
                    information on how to improve performance.
                </p>
            </div>
        )
    }
}
